"use strict";

define('view/selectable.segment',['underscore', 'backbone', 'marionette', 'handlebars', 'uikit/elements/text'], function (_, Backbone, Mn, Handlebars, TextView) {
  var SelectableHeader = TextView.extend({
    tagName: 'div',
    className: 'ui segment attached secondary',
    attributes: {
      style: 'padding: 0.7em 0.8em; outline: none !important',
      tabindex: 0
    },
    template: function template(data) {
      return '<strong>' + Handlebars.escapeExpression(data.text) + '</strong>';
    },
    events: {
      'keydown': function keydown(ev) {
        if (ev.keyCode == 13) {
          this.triggerMethod('press');
        }
      }
    },
    triggers: {
      'click': 'press'
    },
    options: _.extend({}, TextView.prototype.options, {
      selected: false,
      disabled: false
    }),
    update: _.extend({}, TextView.prototype.update, {
      selected: false,
      disabled: false
    }),
    onPress: function onPress() {
      if (!this.disabled) {
        this.selected = true;
      }
    },
    updateAttributes: function updateAttributes() {
      TextView.prototype.updateAttributes.apply(this, arguments);
      if (this.selected && !this.disabled) {
        this.$el.css('background-color', '#0074d9');
        this.$el.css('color', '#fafafa');
      } else {
        this.$el.css('background-color', '');
        this.$el.css('color', 'inherit');
      }
    }
  });
  return SelectableHeader;
});

